"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const novo_1 = __importDefault(require("./novo"));
const novoColorPalette_1 = __importDefault(require("./novoColorPalette"));
// light theme has overrides, the rest are based on the existing "novo" theme
const neoLight = {
    ...novo_1.default,
    action02: novoColorPalette_1.default.offwhite02,
    icon01: novoColorPalette_1.default.offwhite02,
    icon03: novoColorPalette_1.default.offwhite06,
    icon06: novoColorPalette_1.default.offwhite08,
    icon07: novoColorPalette_1.default.offwhite05,
    icon08: novoColorPalette_1.default.offwhite02,
    info01: novoColorPalette_1.default.offwhite09,
    active02: novoColorPalette_1.default.offwhite03,
    active05: novoColorPalette_1.default.offwhite09,
    active08: novoColorPalette_1.default.offwhite09,
    active09: novoColorPalette_1.default.offwhite08,
    active10: novoColorPalette_1.default.offwhite09,
    active12: novoColorPalette_1.default.offwhite085,
    disabled01: novoColorPalette_1.default.offwhite08,
    disabled02: novoColorPalette_1.default.offwhite08,
    disabled03: novoColorPalette_1.default.offwhite05,
    disabled04: novoColorPalette_1.default.offwhite06,
    hover02: novoColorPalette_1.default.offwhite05,
    hover05: novoColorPalette_1.default.offwhite10,
    hover06: novoColorPalette_1.default.offwhite09,
    hover08: novoColorPalette_1.default.offwhite10,
    hover09: novoColorPalette_1.default.offwhite10,
    hover10: novoColorPalette_1.default.offwhite10,
    hover12: novoColorPalette_1.default.offwhite09,
    hover13: novoColorPalette_1.default.offwhite09,
    textColor01: novoColorPalette_1.default.offwhite02,
    textColor02: novoColorPalette_1.default.offwhite05,
    textColor05: novoColorPalette_1.default.offwhite04,
    textColor07: novoColorPalette_1.default.offwhite02,
    ui01: novoColorPalette_1.default.offwhite09,
    ui02: novoColorPalette_1.default.offwhite10,
    ui03: novoColorPalette_1.default.offwhite07,
    ui04: novoColorPalette_1.default.offwhite02,
    ui05: novoColorPalette_1.default.offwhite10,
    ui07: novoColorPalette_1.default.offwhite02,
    ui08: novoColorPalette_1.default.offwhite04,
    ui10: novoColorPalette_1.default.offwhite05,
    ui11: novoColorPalette_1.default.offwhite10,
    ui19: novoColorPalette_1.default.offwhite09,
    ui21: novoColorPalette_1.default.offwhite05,
    ui25: novoColorPalette_1.default.offwhite10,
    brand01: novoColorPalette_1.default.offwhite02,
    statusOffline01: novoColorPalette_1.default.offwhite05,
};
exports.default = neoLight;
